module.exports = __webpack_public_path__ + "static/img/banner.f14d6168.jpg";